var _path, _g, _g2, _path2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranslationMemory = function SvgTranslationMemory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#translation_memory_svg__a)",
    fillRule: "evenodd",
    d: "M60 26.667c-22.091 0-40 17.908-40 40V80c0 17.058 10.678 31.623 25.714 37.374v20.029c0 2.309 2.77 3.465 4.39 1.833L69.191 120H100c22.091 0 40-17.909 40-40V66.667c0-22.092-17.909-40-40-40H60Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#translation_memory_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.643 75.933c-.11-.853-.192-1.72-.192-2.6 0-.88.082-1.746.192-2.6l-5.797-4.413c-.52-.4-.671-1.12-.329-1.707L59 55.373c.342-.573 1.055-.813 1.672-.573l6.824 2.68a20.942 20.942 0 0 1 4.632-2.627l1.028-7.066a1.4 1.4 0 0 1 1.37-1.12h10.963c.686 0 1.247.493 1.357 1.12l1.028 7.066c1.672.68 3.22 1.56 4.632 2.627l6.824-2.68c.617-.227 1.33 0 1.672.573l5.482 9.24a1.312 1.312 0 0 1-.329 1.707l-5.783 4.413c.109.854.192 1.72.192 2.6 0 .88-.083 1.747-.192 2.6l5.783 4.414c.521.4.671 1.12.329 1.706l-5.482 9.24a1.374 1.374 0 0 1-1.672.574l-6.824-2.68a20.942 20.942 0 0 1-4.632 2.626l-1.028 7.067a1.373 1.373 0 0 1-1.357 1.12H74.525a1.373 1.373 0 0 1-1.356-1.12l-1.028-7.067a20.425 20.425 0 0 1-4.632-2.626l-6.825 2.68c-.616.226-1.329 0-1.671-.574l-5.482-9.24a1.311 1.311 0 0 1 .329-1.706l5.783-4.414Zm20.364 6.734c5.303 0 9.593-4.174 9.593-9.334 0-5.16-4.29-9.333-9.593-9.333s-9.593 4.173-9.593 9.333 4.29 9.334 9.593 9.334Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#translation_memory_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#translation_memory_svg__d)",
    d: "M27 59c11.046 0 20-8.954 20-20s-8.954-20-20-20S7 27.954 7 39s8.954 20 20 20Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.894 30.553a1 1 0 0 0-1.788 0l-2.991 5.982a.832.832 0 0 0-.02.037l-.99 1.98a1 1 0 1 0 1.79.895L20.617 38h4.764l.714 1.428a1 1 0 0 0 .926.572h.905a7.022 7.022 0 0 0 1.547 4.265c-.705.394-1.555.66-2.552.738a1 1 0 1 0 .156 1.994c1.562-.123 2.873-.607 3.922-1.322 1.05.715 2.36 1.2 3.922 1.322a1 1 0 1 0 .156-1.994c-.997-.078-1.847-.344-2.552-.738A7.022 7.022 0 0 0 34.073 40H35a1 1 0 1 0 0-2h-3v-1a1 1 0 1 0-2 0v1H27.618l-.714-1.428a1.059 1.059 0 0 0-.018-.037l-2.992-5.982ZM32.074 40H29.926A4.99 4.99 0 0 0 31 42.97 4.99 4.99 0 0 0 32.073 40Zm-7.692-4L23 33.236 21.618 36h2.764ZM23 40a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm7-6a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h1v1Z",
    clipRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#translation_memory_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#translation_memory_svg__f)",
    d: "M130 124c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#translation_memory_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.13 100.793a3.917 3.917 0 0 1 2.37-.793 1.767 1.767 0 0 1 1.5.78 1.759 1.759 0 0 1 1.5-.78 3.917 3.917 0 0 1 2.37.793c.525.408.93.973 1.073 1.656.328.025.628.161.88.366.382.31.66.775.835 1.267.274.765.348 1.74.064 2.57.072.034.143.074.212.12.275.183.484.445.638.754.303.605.428 1.449.428 2.474 0 1.141-.435 1.907-.987 2.38a2.664 2.664 0 0 1-1.054.555c-.1.558-.38 1.204-.819 1.752-.57.715-1.454 1.313-2.64 1.313-.94 0-1.688-.52-2.174-1.03a4.143 4.143 0 0 1-.326-.385c-.101.135-.21.264-.326.385-.486.51-1.233 1.03-2.174 1.03-1.186 0-2.069-.598-2.64-1.313a4.057 4.057 0 0 1-.819-1.752 2.664 2.664 0 0 1-1.054-.555c-.552-.473-.987-1.24-.987-2.38 0-1.025.126-1.87.428-2.474a1.92 1.92 0 0 1 .638-.755c.068-.044.138-.084.212-.118-.284-.832-.21-1.806.064-2.571.175-.492.453-.957.835-1.267.252-.205.552-.34.88-.366.144-.683.548-1.248 1.073-1.656Zm3.37 1.707v-.01l-.002-.05a2.774 2.774 0 0 0-.154-.764 1.228 1.228 0 0 0-.309-.49.764.764 0 0 0-.535-.186 2.916 2.916 0 0 0-1.756.582c-.464.361-.744.85-.744 1.418a.498.498 0 0 1-.658.474c-.188-.062-.356-.027-.535.117-.196.16-.387.444-.524.827-.279.782-.25 1.729.133 2.305a.498.498 0 0 1 .084.277h.75a2.25 2.25 0 0 1 2.25 2.25v.335a1.497 1.497 0 0 1 .978 1.668A1.496 1.496 0 0 1 127 112.5a1.497 1.497 0 0 1-1.478-1.247 1.498 1.498 0 0 1 .978-1.668v-.335c0-.69-.56-1.25-1.25-1.25h-1.75a.476.476 0 0 1-.175-.032l-.003.006c-.198.395-.322 1.051-.322 2.026 0 .859.315 1.343.638 1.62.347.298.732.38.862.38a.5.5 0 0 1 .5.5c0 .368.2 1.011.64 1.563.429.535 1.046.937 1.86.937.56 0 1.062-.313 1.45-.72.191-.2.34-.407.437-.577a1.55 1.55 0 0 0 .113-.236V105.5h-1.085a1.5 1.5 0 1 1 0-1h1.085v-2Zm1 9.999v.967c.031.082.069.161.113.236.098.17.246.377.436.577.389.407.892.72 1.451.72.814 0 1.431-.402 1.86-.937.44-.552.64-1.195.64-1.563a.503.503 0 0 1 .5-.5c.13 0 .515-.082.862-.38.323-.277.638-.761.638-1.62 0-.975-.125-1.63-.322-2.026a.924.924 0 0 0-.3-.37.664.664 0 0 0-.378-.103.498.498 0 0 1-.499-.523.501.501 0 0 1 .083-.254c.384-.576.412-1.523.133-2.305-.137-.383-.328-.668-.524-.827-.179-.144-.347-.18-.535-.117A.498.498 0 0 1 134 103c0-.568-.28-1.057-.745-1.418A2.913 2.913 0 0 0 131.5 101a.764.764 0 0 0-.535.186 1.223 1.223 0 0 0-.31.49 2.581 2.581 0 0 0-.155.814v9.01h.75c.69 0 1.25-.56 1.25-1.25v-1.835a1.5 1.5 0 1 1 1 0v1.835a2.25 2.25 0 0 1-2.25 2.25h-.75v-.001Zm-4-7.499a.5.5 0 1 0 .998.001.5.5 0 0 0-.998-.001Zm6.5 2.5a.5.5 0 1 0 .002-.999.5.5 0 0 0-.002.999Zm-6 3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "translation_memory_svg__a",
    x1: 80,
    x2: 80,
    y1: 26.667,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BB3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#578AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "translation_memory_svg__d",
    x1: 27,
    x2: 27,
    y1: 19,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "translation_memory_svg__f",
    x1: 130,
    x2: 130,
    y1: 92,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECAB03"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "translation_memory_svg__b",
    width: 73.333,
    height: 73.333,
    x: 43.333,
    y: 40.667,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1517_14909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1517_14909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "translation_memory_svg__c",
    width: 50.074,
    height: 50.074,
    x: 4.481,
    y: 16.481,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.519,
    dy: 2.519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.519
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1517_14909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1517_14909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "translation_memory_svg__e",
    width: 40.059,
    height: 40.059,
    x: 111.985,
    y: 89.985,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.015,
    dy: 2.015
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.015
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1517_14909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1517_14909",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "translation_memory_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M122 100h16v16h-16z"
  })))));
};
export default SvgTranslationMemory;